module.exports = __webpack_public_path__ + "media/images/front/icon_pdf-cdc46834dcc3ec49025087891669615d.png";